module.exports = __webpack_public_path__ + "static/media/viettelpay.0832a20e.png";